// 首页首屏与榜单数据
export const hotTopics = [
  {
    id: "hot-1",
    rank: 1,
    tag: "热",
    title: "顶流男团被指舞台假唱，粉丝要求官方公布完整现场",
    heat: 3284,
    category: "娱乐",
    time: "18分钟前",
  },
  {
    id: "hot-2",
    rank: 2,
    tag: "新",
    title: "知名主播带货“翻车”后再开播，弹幕与评论区双双沦陷",
    heat: 2916,
    category: "直播",
    time: "41分钟前",
  },
  {
    id: "hot-3",
    rank: 3,
    tag: "沸",
    title: "一档选秀综艺深夜突发退赛声明，节目组暂未置评",
    heat: 2430,
    category: "综艺",
    time: "1小时前",
  },
  {
    id: "hot-4",
    rank: 4,
    tag: "议",
    title: "品牌方回应代言人争议：已启动合约合规自查",
    heat: 1987,
    category: "商业",
    time: "2小时前",
  },
  {
    id: "hot-5",
    rank: 5,
    tag: "瓜",
    title: "剧组被指分镜抄袭，导演深夜发长文逐帧回应",
    heat: 1654,
    category: "影视",
    time: "3小时前",
  },
];

export const tickerList = [
  "【追踪】假唱风波发酵第3天，主办方承诺将提交场地方完整录像",
  "【最新】某头部主播致歉声明全文流出，称“愿接受一切核实”",
  "【反转】此前被传婚变艺人晒全家同框，工作室确认无恙",
  "【后续】剧组抄袭争议双方各执一词，制片方称已保留原始素材",
  "【进展】选秀节目退赛选手所属公司回应：尊重选手个人选择",
  "【最新】辟谣：网传“某公司大规模裁员”为不实消息",
];

// 首页实时事件追踪的站内栏目导航
export const navSections = [
  { id: "headline", label: "头条" },
  { id: "tracking", label: "事件追踪" },
  { id: "reversal", label: "反转专区" },
  { id: "feed", label: "最新爆料" },
  { id: "ranking", label: "吃瓜热榜" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于我们" },
];